<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.fBillNo"
        placeholder="编号"
        size="small"
        style="width: 200px"
      />
      <el-date-picker
        v-model="query.fYear"
        type="year"
        placeholder="选择年"
        value-format="yyyy"
        format="yyyy年"
        size="small"
      />
      <el-date-picker
        v-model="query.fMonth"
        type="month"
        placeholder="选择月"
        value-format="M"
        format="M月"
        size="small"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
      >添加</el-button>
      <!-- <el-button type="primary" size="small" @click="delSystemPeople">删除</el-button> -->
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fBillNo" label="编号" />
        <el-table-column prop="fYear" label="年份" />
        <el-table-column prop="fMonth" label="月份" />
        <el-table-column prop="fQuota" label="额度" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_read(scope.row)"
              >查看</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import EditForm from './EditForm'
import readForm from './readForm'
import ConfirmButton from '@components/ConfirmButton'
export default {
  components: {
    EditForm,
    ConfirmButton,
    readForm
  },
  data() {
    return {
      query: {
        fBillNo: null,
        fYear: (new Date()).getFullYear().toString(),
        fMonth: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      tableData: [],
      loading: false,
      canAdd: true,
      canEdit: true,
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key === '004004002') {
        this.canAdd = val.isGrant
      }
      if (val.key === '004004002') {
        this.canEdit = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost(
        'BasicInformation/DistributorQuota/MonthQuotaEntry',
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }

          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    // 查看获取月度销售额接口
    _read: async function(row) {
      this.currentreadItem = await this.$httpPost(
        'BasicInformation/DistributorQuota/GetMonthQuota',
        { fBillNo: row.fBillNo }
      ).then((res) => res.datalist)
      const h = this.$createElement
      this.$formDlg({
        title: '查看月度销售额',
        formTpl: <readForm form={this.currentreadItem}></readForm>,
        formSubmit: (formData) => this.readpostData(formData),
        width: '50%',
        readonly: !this.canAdd
      })
    },
    readpostData(modifyType, info) {
      return this.$httpPost(
        `BasicInformation/DistributorQuota/SaveMonthQuota`,
        {
          datalist: JSON.stringify({
            ...modifyType,
            info
          })
        }
      ).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    // 新增经销商
    _modify: async function(row) {
      const distributorList = await this.$httpPost(
        'BasicInformation/Distributor/DistributorChoiceEntry', { prohibit: true }
      ).then((res) => res.datalist)
      const date = new Date()
      const year = date.getFullYear()
      const yearList = [year - 1, year, year + 1, year + 2]

      this.currentEditItem = {
        distributorList,
        yearList,
        yearData: year,
        infoEntrys: null,
        fDistributorID: '',
        fYear: ''
      }
      const h = this.$createElement
      this.$formDlg({
        title: `新增月度销售额`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(formData),
        width: '50%',
        readonly: !this.canEdit
      })
    },
    // async _delete(row) {
    //   this.currentEditItem = await this.$httpPost('BasicInformation/KdCompany/GetKdCompany', { fid: row.fid }).then(res => res.datalist)
    //   this.postData(2, this.currentEditItem)
    // },
    postData(modifyType) {
      // console.log(modifyType, 'modifyType')
      return this.$httpPost(
        `BasicInformation/DistributorQuota/AddDistributorQuota`,
        {
          datalist: JSON.stringify({
            fDistributorID: modifyType.fDistributorID,
            fYear: modifyType.fYear,
            infoEntrys: modifyType.infoEntrys
          })
        }
      ).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    }
  }
}
</script>
<style lang="">
</style>
